import { render, staticRenderFns } from "./CorporateCreate.vue?vue&type=template&id=08961e3a&scoped=true"
import script from "./CorporateCreate.vue?vue&type=script&lang=js"
export * from "./CorporateCreate.vue?vue&type=script&lang=js"
import style0 from "./CorporateCreate.vue?vue&type=style&index=0&id=08961e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08961e3a",
  null
  
)

export default component.exports